module.exports = "<lfwms-result-data-table [searchService]=\"searchService\" [tableMode]=\"searchService.displayMode\" (buttonActionHandler)=\"buttonService.handleMainButtonPanelActionsForTable($event, widgetConfig.id)\"></lfwms-result-data-table>\n    "


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/advance-configuration-table-widget/advance-configuration-table-widget.html
// module id = ../../../../../src/app/shared/components/widget/advance-configuration-table-widget/advance-configuration-table-widget.html
// module chunks = main